import {
  AxonEventNames,
  AxonViewItemParams,
  AxonAddToCartParams,
  AxonBeginCheckoutParams,
  AxonPurchaseParams,
} from '../../entities';
import { AppnebulaAxonService, AxonService } from '../../interfaces';

export class AppnebulaHttpAxonService implements AppnebulaAxonService {
  constructor(private readonly axonService: AxonService) {}

  pageView(): void {
    this.axonService.track(AxonEventNames.PAGE_VIEW);
  }

  viewItem({ items, currency }: AxonViewItemParams): void {
    const axonItems = items.map((item) => ({
      item_id: item.productId,
      item_variant_id: item.productId,
      price: item.price,
    }));

    this.axonService.track(AxonEventNames.VIEW_ITEM, {
      items: axonItems,
      currency,
    });
  }

  addToCart({ productId, price, currency }: AxonAddToCartParams): void {
    this.axonService.track(AxonEventNames.ADD_TO_CART, {
      items: [
        {
          item_id: productId,
          item_variant_id: productId,
          price,
          quantity: 1,
        },
      ],
      currency,
    });
  }

  beginCheckout({ productId, price, currency }: AxonBeginCheckoutParams): void {
    this.axonService.track(AxonEventNames.BEGIN_CHECKOUT, {
      items: [
        {
          item_id: productId,
          item_variant_id: productId,
          price,
        },
      ],
      currency,
      value: price,
    });
  }

  purchase({ productId, price, currency, paymentId, email, nebulaId }: AxonPurchaseParams): void {
    this.axonService.track(AxonEventNames.PURCHASE, {
      items: [
        {
          item_id: productId,
          item_variant_id: productId,
          price,
          quantity: 1,
        },
      ],
      currency,
      value: price,
      shipping: 0,
      tax: 0,
      transaction_id: paymentId,
      user_data: {
        email,
        user_id: nebulaId,
      },
    });
  }
}
